import {GovIcon, GovModal} from "@gov-design-system-ce/react";
import {IconProps} from "../icon/Icon";

export interface ModalProps {
    open: boolean;
    label?: string;
    children?: React.ReactNode;
    iconProps?: IconProps;
    onClose?: () => void;
    maxWidth?: string;
}

export default function Modal(props: ModalProps) {
    const {open, children, label, iconProps, onClose, maxWidth} = props;

    return (
        <GovModal open={open} label={label} onGov-close={onClose}
                  style={maxWidth ? {"--gov-modal-max-width": maxWidth} as React.CSSProperties : undefined}>
            <GovIcon slot={"icon"} {...iconProps}/>
            <div>{children}</div>
        </GovModal>
    );
}
